import { AutomationStatus } from "../../config/enums";
import { badgeClassName } from "../../elements/badgeClassName";

const Variants: Record<string, string> = {
  Published: "success",
  Testing: "warning",
};

/** An automation's status as a badge, nothing for a status it does not know. */
export function AutomationStatusBadge({ status }: { status?: number | null }) {
  const label = Object.entries(AutomationStatus).find(
    ([, value]) => value === status
  )?.[0];

  return label ? (
    <span className={`${badgeClassName(Variants[label] ?? "info")} me-2`}>
      {label}
    </span>
  ) : null;
}

export default AutomationStatusBadge;
